<!-- NAV -->
<nav>
  <a class="logo" href="https://web.askbuddy.ai">
    <div class="logo-icon">L</div>
    <span class="logo-name">LIAM</span>
  </a>
  <div class="nav-right">
    <a class="nav-link" [routerLink]="['/story']">Our Story</a>
    <a class="nav-link" [routerLink]="['/login']">Sign In</a>
    <a class="btn-nav" href="/liam.mcpb" download="liam.mcpb">⬇ Download</a>
  </div>
</nav>

<!-- HERO -->
<section class="hero">
  <div class="hero-left">
    <div class="hero-logo">L</div>
    <h1>Remember everything.<br/><span class="orange">Install anywhere.</span></h1>
    <p class="hero-desc">
      Add LIAM to Claude Desktop in seconds. Your contacts, notes, recipes, and spending — all remembered, always recalled.
    </p>
    <div class="hero-cta">
      <a class="btn-primary" href="/liam.mcpb" download="liam.mcpb">⬇ Download LIAM</a>
      <a class="btn-outline" href="https://web.askbuddy.ai" target="_blank">Learn more →</a>
    </div>
    <p class="file-note">liam.mcpb · Mac &amp; Windows · Free</p>
  </div>

  <!-- Install steps card -->
  <div class="install-card">
    <h2>Get started in 3 steps</h2>
    <p class="sub">No technical knowledge needed · ~2 minutes</p>

    <div class="step-row">
      <div class="step-circle">1</div>
      <div class="step-content">
        <h4>Download the file</h4>
        <p>Click the button below. A file called <strong>liam.mcpb</strong> saves to your Downloads folder.</p>
      </div>
    </div>
    <div class="step-row">
      <div class="step-circle">2</div>
      <div class="step-content">
        <h4>Double-click to install</h4>
        <p><strong>Double-click liam.mcpb</strong> — Claude Desktop opens and shows an install prompt. Click <strong>Install</strong>.</p>
      </div>
    </div>
    <div class="step-row">
      <div class="step-circle">3</div>
      <div class="step-content">
        <h4>Sign in with Google</h4>
        <p>A browser tab opens. <strong>Sign in with Google</strong> — your memory is now connected to Claude.</p>
      </div>
    </div>

    <a class="card-download" href="/liam.mcpb" download="liam.mcpb">⬇ Download LIAM — it's free</a>
    <p class="card-note">Requires Claude Desktop · <a href="https://claude.ai/download" target="_blank" style="color:#bbb">Download Claude →</a></p>
  </div>
</section>

<!-- REQUIREMENT BANNER -->
<div class="req-banner">
  <div class="req-inner">
    💡 <span><strong>Don't have Claude Desktop?</strong> <a href="https://claude.ai/download" target="_blank">Download it free here</a> first, then come back to install LIAM.</span>
  </div>
</div>

<!-- FEATURES -->
<section class="features-section">
  <h2>What LIAM remembers for you</h2>
  <p class="sub">Just talk to Claude naturally — LIAM handles the rest.</p>
  <div class="features-grid">
    <div class="feature-card">
      <div class="feature-icon">👥</div>
      <h4>Contacts</h4>
      <p>"Remember Sarah — she's a VP at Acme." Claude recalls her next time.</p>
    </div>
    <div class="feature-card">
      <div class="feature-icon">📝</div>
      <h4>Notes &amp; Ideas</h4>
      <p>"Save this idea." Claude finds it weeks later, no searching needed.</p>
    </div>
    <div class="feature-card">
      <div class="feature-icon">🍳</div>
      <h4>Recipes</h4>
      <p>Store your recipes and ask Claude to plan meals around them.</p>
    </div>
    <div class="feature-card">
      <div class="feature-icon">🥗</div>
      <h4>Food Log</h4>
      <p>Snap a meal photo or type it — get daily nutrition summaries.</p>
    </div>
    <div class="feature-card">
      <div class="feature-icon">🧾</div>
      <h4>Spending</h4>
      <p>"How much did I spend on food this week?" — Claude knows.</p>
    </div>
    <div class="feature-card">
      <div class="feature-icon">🔒</div>
      <h4>Private &amp; Secure</h4>
      <p>Tied to your Google account. Only you can access your memory.</p>
    </div>
  </div>
</section>

<!-- BOTTOM CTA -->
<section class="bottom-cta">
  <h2>Give Claude a <span>permanent memory</span></h2>
  <p>Free to install. Works with the Claude app you already have.</p>
  <a class="btn-orange-outline" href="/liam.mcpb" download="liam.mcpb">⬇ Download LIAM — it's free</a>
</section>

<!-- FOOTER -->
<footer>
  Made by <a href="https://netxd.com" target="_blank">NetXD</a>
  <span class="sep">·</span>
  <a [href]="links.privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
  <span class="sep">·</span>
  <a [href]="links.terms" target="_blank" rel="noopener noreferrer">Terms of Use</a>
  <span class="sep">·</span>
  <a [href]="links.support" target="_blank" rel="noopener noreferrer">Support</a>
  <span class="sep">·</span>
  <a href="https://web.askbuddy.ai" target="_blank">web.askbuddy.ai</a>
</footer>
